/* Definitions of actions coming from the cluster (hooked from app events) */
export const HTTP_REQUEST_STARTED = 'app-action/http-request-started';
export const HTTP_REQUEST_SUCCEEDED = 'app-action/http-request-succeed';
export const HTTP_REQUEST_FAILED = 'app-action/http-request-failed';


export const httpRequestStarted = (requestedAction, response) => ({
  type: HTTP_REQUEST_STARTED,
  payload: {
    requestedAction
  }
});

export const httpRequestSucceeded = (requestedAction, response) => ({
  type: HTTP_REQUEST_SUCCEEDED,
  payload: {
    requestedAction,
    response
  }
});

export const httpRequestFailed = (requestedAction, exception) => ({
  type: HTTP_REQUEST_FAILED,
  payload: {
    requestedAction,
    exception
  }
});
